module.exports = __webpack_public_path__ + "img/leiyu.1a823367.png";